import React from 'react';
import { Row as AntRow, RowProps } from 'antd';

function Row(props: RowProps) {
  return <AntRow {...props} />;
}

export default Row;
